import PartChecklist from '@src/components/PartChecklist';
import { useQuery, useSaveItemSpecificsMutation } from '@src/query';


/** Fillable item-specifics checklist for the CopyModal eBay tab (#273).
 *
 * Data wiring only — the widget itself is the shared `PartChecklist` (#277 extracted
 * it so the inspection checklist renders identically). What lives here is the part of
 * the feature that is genuinely its own: the item-specifics endpoint, the `specifics`
 * PATCH body key, and the listing-copy invalidation the mutation performs so generated
 * copy reflects newly-stored specifics. */
function ItemSpecificsChecklist({ sellerId, partId, canWrite, onSaved }) {
  const query = useQuery(`/inventory/parts/${sellerId}/${partId}/item-specifics/`);
  const save = useSaveItemSpecificsMutation();

  return (
    <PartChecklist
      query={query}
      canWrite={canWrite}
      saving={save.isPending}
      title="Item specifics checklist"
      savedMessage="Item specifics saved"
      onSaved={onSaved}
      onSave={(specifics, callbacks) => save.mutate({ sellerId, partId, specifics }, callbacks)}
    />
  );
}

ItemSpecificsChecklist.displayName = 'ItemSpecificsChecklist';
export default ItemSpecificsChecklist;
